import ShopGridHeader from "./shop-grid-header";

export default ShopGridHeader;